import { createFileRoute } from '@tanstack/react-router';
import { rulesQuery } from '@/features/rules/api';
import { NewRulePage } from '@/features/rules/pages/NewRulePage';
import { newRuleSearchSchema } from '@/features/rules/search';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/rules/new')({
  staticData: { help: 'trust-rules' },
  validateSearch: newRuleSearchSchema,
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(rulesQuery());
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: NewRulePage,
});
